<template>
  <v-card class="folie">
    <v-container>
      <v-card-title class="display-3">{{ this.title }}</v-card-title>
      <v-card-text class="title" fill-height align="start">
        <slot></slot>
      </v-card-text>
      <v-img :src="imgsrc" class="float-right image"></v-img>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "FolieMitBild",
  props: {
    title: String,
    imgsrc: String
  }
};
</script>

<style scoped>
.folie {
  min-height: 80vh;
}
.image {
  max-width: 20%;
}
</style>
